export class HttpRetryError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, HttpRetryError.prototype);
  }
}
